// Copyright (c) 2025 WiseTime. All rights reserved.

import { createAction } from "@reduxjs/toolkit"
import {
  GetTrainingNarrativeRequest,
  ListTrainingGroupsRequest,
  SetNarratePreferencesRequest,
} from "../../generated/wisetime/user/assistant/v4/preferences_pb"

export const getDefaultNarratePreferences = createAction("narrate-preferences/get-default-narrate-preferences")
export const getSavedNarratePreferences = createAction("narrate-preferences/get-saved-narrate-preferences")
export const setNarratePreferences = createAction<SetNarratePreferencesRequest>("narrate-preferences/set-narrate-preferences")
export type ListTrainingGroupsPayload = {
  request: ListTrainingGroupsRequest,
  replaceGroupId?: string,
}
export const listTrainingGroups = createAction<ListTrainingGroupsPayload>("narrate-preferences/list-training-groups")
export const getTrainingNarrative = createAction<GetTrainingNarrativeRequest>("narrate-preferences/get-training-narrative")
